import { useCallDetailsStore } from "@/call-details";
import type { IVRInfo } from "@/sdk";
import { isVoiceTask, useMostRecentTask, usePartner } from "@/sdk";
import { getMappedIntent } from "./getMappedIntent";

export function useIVRInfo() {
    const task = useMostRecentTask();
    const voiceTask = isVoiceTask(task) ? task : null;
    const partner = usePartner();

    const {
        intent: intentFromVoiceTask,
        summary: summaryFromVoiceTask,
        customerName: customerNameFromVoiceTask,
        orderNumber: orderNumberFromVoiceTask,
        productLink: productLinkFromVoiceTask,
    } = voiceTask?.ivrInfo || {};

    const {
        INTENT: intentFromCSD,
        SUMMARY: summaryFromCSD,
        CUSTOMER_NAME: customerNameFromCSD,
        ORDER_NUMBER: orderNumberFromCSD,
        PRODUCT_LINK: productLinkFromCSD,
    } = useCallDetailsStore((state) => state.callDetails);

    const intent = intentFromVoiceTask ? getMappedIntent(intentFromVoiceTask, partner) : intentFromCSD;
    const summary = summaryFromVoiceTask ?? summaryFromCSD;
    const customerName = customerNameFromVoiceTask ?? customerNameFromCSD;
    const orderNumber = orderNumberFromVoiceTask ?? orderNumberFromCSD;
    const productLink = productLinkFromVoiceTask ?? productLinkFromCSD;

    return { ...voiceTask?.ivrInfo, intent, summary, customerName, orderNumber, productLink };
}

export function getIVRInfoFromCSD() {
    const {
        INTENT: intent,
        SUMMARY: summary,
        CUSTOMER_NAME: customerName,
        ORDER_NUMBER: orderNumber,
        PRODUCT_LINK: productLink,
    } = useCallDetailsStore.getState().callDetails;
    return { intent, summary, customerName, orderNumber, productLink } as IVRInfo;
}
